import React from 'react';

const Burger = props => (
	<svg width="22" height="17" viewBox="0 0 22 17" fill="#9B9B9B" {...props}>
		<path d="M1 2a1 1 0 1 1 0-2h20a1 1 0 1 1 0 2H1zm0 15a1 1 0 1 1 0-2h20a1 1 0 1 1 0 2H1zm0-7.5a1 1 0 1 1 0-2h20a1 1 0 1 1 0 2H1z"/>
	</svg>
);

export default Burger;
